export default __webpack_public_path__ + "images/pictograms/photo-products.svg?7eb9584973c26183afb0bd576624b29a225a42473d365cc300fa70c705fd7f47";